import React from "react";
import { StripeFieldValidationTemplate } from "themes/common/components";

function StripeFieldValidation(props) {
    return <StripeFieldValidationTemplate {...props} />;
}

export default StripeFieldValidation;
